// FAQ accordion (spec D7): a click anywhere on an item opens it, the next one closes it.
// The answer's height runs between 0 and its measured content height (then auto), and the
// icon turns from 45° to 0°, both over 400 ms; the CSS of the state class below holds the
// two end states and the transitions.

import { afterTransition, prefersReducedMotion } from "./transitions.js";

const SELECTORS = {
  item: ".accordion-item",
  content: ".accordion-item-content",
};

const OPEN = "is-open";
const DURATION_MS = 400;

function toggle(item, content, state) {
  state.cancel?.();
  state.cancel = null;
  const opening = !item.classList.contains(OPEN);
  if (prefersReducedMotion()) {
    item.classList.toggle(OPEN, opening);
    content.style.height = "";
    return;
  }
  // Pin the current height (auto when open, or mid-transition), then run to the target.
  content.style.height = `${content.getBoundingClientRect().height}px`;
  void content.offsetHeight;
  item.classList.toggle(OPEN, opening);
  content.style.height = opening ? `${content.scrollHeight}px` : "0px";
  // Hand the end state back to the CSS: auto when open, 0 when closed.
  state.cancel = afterTransition(content, "height", DURATION_MS, () => {
    state.cancel = null;
    content.style.height = "";
  });
}

export function initAccordion() {
  for (const item of document.querySelectorAll(SELECTORS.item)) {
    const content = item.querySelector(SELECTORS.content);
    if (!content) continue;
    const state = { cancel: null };
    item.addEventListener("click", () => toggle(item, content, state));
  }
}
